/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { PrefectFlow } from '@poweralpha/common';

/**
 * Query keys for Prefect flow-run status. After launching a run, invalidate
 * `simulationRunKeys.all` so every run list and the top-bar progress pick it up.
 */
export const simulationRunKeys = {
  all: ['simulation-runs'] as const,
  /** The user's runs, paged (Home "My runs"). */
  list: () => [...simulationRunKeys.all, 'list'] as const,
  /** The user's latest runs with progress (top-bar pill). */
  progress: () => [...simulationRunKeys.all, 'progress'] as const,
  /** The user's runs of the given flows. */
  byFlow: (flowNames: ReadonlyArray<PrefectFlow>) =>
    [...simulationRunKeys.all, 'flow', ...flowNames] as const,
};
